import React, { useState } from 'react';
import { Trash, Loader2 } from 'lucide-react';
import Modal from '../ui/Modal';
import ConfirmClickButton from '../ui/ConfirmClickButton';
import { COMMON_INPUT_CLASS, USER_ROLE } from '../../utils/constants';

const ProfilDuzenleModal = ({
  isOpen, onClose, loggedInUser, updateStudentData, updateInstructorData, showToast, setActiveModal,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isStudent = loggedInUser?.role === USER_ROLE.STUDENT
    || loggedInUser?.role === 'student';

  return (
    <Modal title="Kişisel Bilgileri Düzenle" isOpen={isOpen} onClose={onClose}>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          if (isSubmitting) return;
          const name = e.target.name.value.trim();
          if (!name) {
            showToast?.('Ad soyad boş olamaz.', 'error');
            return;
          }
          setIsSubmitting(true);
          try {
            let success = false;
            if (isStudent) {
              success = await updateStudentData(loggedInUser.id, {
                name,
                age: parseInt(e.target.age.value, 10) || 0,
                parent: e.target.parent.value.trim() || '-',
              });
              if (success) showToast?.('Profil güncellendi.');
            } else {
              success = await updateInstructorData(loggedInUser.id, {
                name,
                specialty: e.target.specialty.value.trim() || 'Yüzme Eğitmeni',
              });
              if (success) showToast?.('Eğitmen profili güncellendi.');
            }
            if (success) onClose();
          } finally {
            setIsSubmitting(false);
          }
        }}
        className="space-y-4"
      >
        <div>
          <label htmlFor="profil-name" className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">
            Ad Soyad
          </label>
          <input
            id="profil-name"
            name="name"
            type="text"
            defaultValue={loggedInUser?.name || ''}
            required
            maxLength={80}
            autoComplete="name"
            className={COMMON_INPUT_CLASS}
          />
        </div>

        {isStudent ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="profil-age" className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">
                Öğrenci Yaşı
              </label>
              <input
                id="profil-age"
                name="age"
                type="number"
                min={1}
                max={120}
                defaultValue={loggedInUser?.age}
                required
                className={COMMON_INPUT_CLASS}
              />
            </div>
            <div>
              <label htmlFor="profil-parent" className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">
                Veli Adı
              </label>
              <input
                id="profil-parent"
                name="parent"
                defaultValue={loggedInUser?.parent === '-' ? '' : loggedInUser?.parent}
                placeholder="Yoksa boş bırakın"
                maxLength={80}
                className={COMMON_INPUT_CLASS}
              />
            </div>
          </div>
        ) : (
          <div>
            <label htmlFor="profil-specialty" className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">
              Uzmanlık Alanı
            </label>
            <input
              id="profil-specialty"
              name="specialty"
              defaultValue={loggedInUser?.specialty || 'Yüzme Eğitmeni'}
              maxLength={80}
              className={COMMON_INPUT_CLASS}
            />
          </div>
        )}

        <p className="text-xs text-slate-400 leading-relaxed">
          Üye numaranız (#
          {loggedInUser?.userCode}
          ) değiştirilemez. E-posta ve telefonu hesap ayarlarındaki iletişim bölümünden güncelleyebilirsiniz.
        </p>

        <ConfirmClickButton
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold mt-4 hover:bg-blue-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isSubmitting ? (
            <>
              <Loader2 size={18} className="animate-spin" />
              Kaydediliyor...
            </>
          ) : (
            'Değişiklikleri Kaydet'
          )}
        </ConfirmClickButton>
      </form>
      {loggedInUser?.role === 'instructor' && (
        <div className="mt-6 pt-6 border-t border-slate-100 dark:border-slate-800">
          <button
            type="button"
            onClick={() => setActiveModal('deleteAccountConfirm')}
            className="w-full flex items-center justify-center gap-2 text-red-500 bg-red-50 dark:bg-red-900/20 py-4 rounded-xl font-bold hover:bg-red-100 dark:hover:bg-red-900/40 transition-colors"
          >
            <Trash size={18} /> Hesabımı Kalıcı Olarak Sil
          </button>
        </div>
      )}
    </Modal>
  );
};

export default ProfilDuzenleModal;
